const CurrentPets = ({ currentCatsCount = null, currentDogsCount = null }) => ({
  currentCatsCount: currentCatsCount && String(currentCatsCount),
  currentDogsCount: currentDogsCount && String(currentDogsCount),
});

const CurrentRoommatesDetails = ({
  roommateDetailsDescription = '',
  roommateFemaleCount = '',
  roommateMaleCount = '',
  roommateNonBinaryCount = '',
  roommatePreferNotToIdentifyCount = '',
  roommateTotalCount = '',
}) => ({
  roommateDetailsDescription: String(roommateDetailsDescription),
  roommateFemaleCount: String(roommateFemaleCount),
  roommateMaleCount: String(roommateMaleCount),
  roommateNonBinaryCount: String(roommateNonBinaryCount),
  roommatePreferNotToIdentifyCount: String(roommatePreferNotToIdentifyCount),
  roommateTotalCount: String(roommateTotalCount),
});

const RoommateRequirements = ({ roommateGenderPreferences = [], roommateMinAgePreference = null }) => ({
  roommateGenderPreferences: roommateGenderPreferences,
  roommateMinAgePreference: roommateMinAgePreference && Number(roommateMinAgePreference),
});

const RoomForRent = ({
  tenantDescription = '',
  roomHasPrivateBathroom = false,
  roomIsFurnished = false,
  roomSquareFeet = '',
  utilitiesIncluded = {},
  hasPermissionToCreateListing = false,
  currentRoommatesDetails = {},
  roommateRequirements = {},
  currentPets = {},
  monthlyUtilitiesShareDescription = '',
} = {}) => ({
  tenantDescription: String(tenantDescription),
  roomHasPrivateBathroom: Boolean(roomHasPrivateBathroom),
  roomIsFurnished: Boolean(roomIsFurnished),
  roomSquareFeet: String(roomSquareFeet),
  utilitiesIncluded: Object(utilitiesIncluded),
  hasPermissionToCreateListing: Boolean(hasPermissionToCreateListing),
  currentRoommatesDetails: CurrentRoommatesDetails(currentRoommatesDetails),
  roommateRequirements: RoommateRequirements(roommateRequirements),
  currentPets: CurrentPets(currentPets),
  monthlyUtilitiesShareDescription: String(monthlyUtilitiesShareDescription),
});

export default RoomForRent;

export type RoomForRentProps = ReturnType<typeof RoomForRent>;
